// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://townofbelleair-vendor.aclarian.com',
  appName: 'Town of Belleair | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub00881aec7404a535df2c69ae802ea883',
  datadogApplicationId: '3e0412bd-c9f0-42dd-88ba-68f9beb4439b',
  datadogService: 'invoicing_belleair_prod',
  ApiKey: 'Qq2@ZJH%vL95Fp#O',
  env: 'PROD',
  version: packageInfo.version,
};
